import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart3, Mail, Users, Briefcase } from 'lucide-react';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const isPro = window.location.hostname === 'pro.dpewizard.com';

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo & Description */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-green-500 rounded-lg flex items-center justify-center">
                <BarChart3 className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold">DPEWizard</span>
            </div>
            <p className="text-gray-400 text-sm">
              Plateforme d'analyse DPE intelligente avec données officielles ADEME.
            </p>
          </div>

          {/* Navigation principale */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => navigate('/')}
                  className="text-gray-400 hover:text-white transition-colors text-left"
                >
                  Accueil
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/pricing')}
                  className="text-gray-400 hover:text-white transition-colors text-left"
                >
                  Tarifs
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/about')}
                  className="text-gray-400 hover:text-white transition-colors text-left"
                >
                  À propos
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/contact')}
                  className="text-gray-400 hover:text-white transition-colors text-left"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="flex items-center space-x-3 mb-6">
              <Mail className="w-5 h-5 text-gray-400" />
              <a
                href="mailto:support@dpewizard.com"
                className="text-gray-400 hover:text-white transition-colors"
              >
                support@dpewizard.com
              </a>
            </div>
            <h3 className="text-lg font-semibold mb-4">Vous êtes...</h3>
            <ul className="space-y-2">
              <li>
                {isPro ? (
                  <a
                    href="https://dpewizard.com"
                    className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors text-left group"
                  >
                    <Users className="w-4 h-4 group-hover:text-blue-400 transition-colors" />
                    <span>Particulier</span>
                  </a>
                ) : (
                  <button
                    onClick={() => navigate('/')}
                    className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors text-left group"
                  >
                    <Users className="w-4 h-4 group-hover:text-blue-400 transition-colors" />
                    <span>Particulier</span>
                  </button>
                )}
              </li>
              <li>
                {isPro ? (
                  <button
                    onClick={() => navigate('/')}
                    className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors text-left group"
                  >
                    <Briefcase className="w-4 h-4 group-hover:text-blue-400 transition-colors" />
                    <span>Professionnel</span>
                  </button>
                ) : (
                  <button
                    onClick={() => navigate('/pro')}
                    className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors text-left group"
                  >
                    <Briefcase className="w-4 h-4 group-hover:text-blue-400 transition-colors" />
                    <span>Professionnel</span>
                  </button>
                )}
              </li>
            </ul>
          </div>
        </div>

        <hr className="border-gray-800 my-6" />

        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            &copy; {currentYear} DPEWizard. Tous droits réservés.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <button 
              onClick={() => navigate('/privacy')}
              className="text-gray-400 hover:text-white text-sm transition-colors"
            >
              Confidentialité
            </button>
            <button 
              onClick={() => navigate('/terms')}
              className="text-gray-400 hover:text-white text-sm transition-colors"
            >
              CGU
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;